module.exports = __webpack_public_path__ + "assets_1789457014240/img/logo.a6acaf61.png";